export default {
    methods: {
        emitInput(name, value) {
            this.$emit('inputs', {name, value});
        },
    },
};
